/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientIdentity } from './';
import {
    ClientIdentityFromJSON,
    ClientIdentityFromJSONTyped,
    ClientIdentityToJSON,
} from './';

/**
 * 
 * @export
 * @interface AvailableIdentities
 */
export interface AvailableIdentities {
    /**
     * 
     * @type {ClientIdentity}
     * @memberof AvailableIdentities
     */
    current: ClientIdentity;
    /**
     * All available client identities when user is connected
     * @type {Array<ClientIdentity>}
     * @memberof AvailableIdentities
     */
    all: Array<ClientIdentity>;
}

/**
 * Check if a given object implements the AvailableIdentities interface.
 */
export function instanceOfAvailableIdentities(value: object): value is AvailableIdentities {
    if (!('current' in value) || value['current'] === undefined) return false;
    if (!('all' in value) || value['all'] === undefined) return false;
    return true;
}

export function AvailableIdentitiesFromJSON(json: any): AvailableIdentities {
    return AvailableIdentitiesFromJSONTyped(json, false);
}

export function AvailableIdentitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableIdentities {
    if (json == null) {
        return json;
    }
    return {
        
        'current': ClientIdentityFromJSON(json['current']),
        'all': ((json['all'] as Array<any>).map(ClientIdentityFromJSON)),
    };
}

export function AvailableIdentitiesToJSON(value?: AvailableIdentities | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'current': ClientIdentityToJSON(value['current']),
        'all': ((value['all'] as Array<any>).map((v) => ClientIdentityToJSON(v))),
    };
}

